export const baseUrl = 'https://sandboxuat.centralindia.cloudapp.azure.com';

export const integrity = '2H7g8BG75Zsc1NJTdljBBmr79KI3qEMrefR0LZQ';
